import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiButton } from "@ryde/controls";
import { TDrawerCloseFunction } from "@ryde/shared";

import { FormFooterStyled } from "../../../drawer";

interface INotificationEditFooterProps {
  onCloseDrawer: TDrawerCloseFunction;
  onSave: () => void;
  isSave: boolean;
}

export const NotificationEditFooter: FC<INotificationEditFooterProps> = ({
  onCloseDrawer,
  onSave,
  isSave,
}) => {
  const { t } = useTranslation();

  const onCancelClick = (): void => {
    onCloseDrawer();
  };

  const onSaveClick = (): void => {
    onSave();
  };

  return (
    <FormFooterStyled>
      <MuiButton
        e2eData="notification-edit-cancel-button"
        muiVariant="outlined"
        color="secondary"
        onClick={onCancelClick}
      >
        {t(`general.CLOSE`)}
      </MuiButton>
      {isSave && (
        <MuiButton
          e2eData="notification-edit-resolve-button"
          muiStyle="primary"
          onClick={onSaveClick}
        >
          {t(`notification.RESOLVED`)}
        </MuiButton>
      )}
    </FormFooterStyled>
  );
};
